{
  "INBOX_MGMT": {
    "HEADER": "Inboxes",
    "DESCRIPTION": "A channel is the mode of communication your customer chooses to interact with you. An inbox is where you manage interactions for a specific channel. It can include communications from various sources such as email, live chat, and social media.",
    "LEARN_MORE": "Learn more about inboxes",
    "RECONNECT": {
      "BUTTON": "Rilidhu",
      "FACEBOOK": "Lidhja me Facebook skadoi ose u revokua. Mesazhet që dërgohen te faqja nuk vijnë në këtë kuti hyrëse dhe përgjigjet mund të dështojnë. Një person që menaxhon faqen e Facebook duhet të klikojë Rilidhu dhe të hyjë në Facebook.",
      "INSTAGRAM": "Lidhja me Instagram skadoi ose u revokua. Mesazhet që dërgohen te llogaria nuk vijnë në këtë kuti hyrëse dhe përgjigjet mund të dështojnë. Klikoni Rilidhu dhe hyni në të njëjtën llogari Instagram. Një llogari tjetër krijon një kuti hyrëse të re.",
      "GOOGLE": "Lidhja me Google skadoi ose u revokua. Email-et e reja nuk vijnë në këtë kuti hyrëse dhe përgjigjet mund të dështojnë. Klikoni Rilidhu dhe hyni në Google si {email}.",
      "MICROSOFT": "Lidhja me Microsoft skadoi ose u revokua. Email-et e reja nuk vijnë në këtë kuti hyrëse dhe përgjigjet mund të dështojnë. Klikoni Rilidhu dhe hyni në Microsoft si {email}.",
      "ALLEGRO": "Lidhja me Allegro skadoi ose u revokua. Mesazhet e blerësve nuk vijnë në këtë kuti hyrëse dhe përgjigjet mund të dështojnë. Klikoni Rilidhu dhe hyni në Allegro si shitësi {seller}. Një llogari tjetër shitësi krijon një kuti hyrëse të re.",
      "IMAP_LOGIN": "Serveri i postës refuzon hyrjen në IMAP si {login}. Email-et e reja nuk mbërrijnë në këtë kuti. Kontrolloni emrin e hyrjes dhe fjalëkalimin për IMAP te skeda {tab} dhe ruajini. Vazhdojmë të provojmë të hyjmë, dhe kutia do të rikuperohet sapo hyrja të funksionojë.",
      "WHATSAPP": "Lidhja me WhatsApp ka skaduar ose është revokuar. Bashkëngjitjet nga klientët nuk mbërrijnë në këtë kuti, dhe përgjigjet mund të dështojnë. Klikoni Rilidhu, hyni në Facebook dhe zgjidhni përsëri numrin {phone}."
    },
    "LIST": {
      "404": "There are no inboxes attached to this account.",
      "RECONNECT_REQUIRED": "Duhet rilidhur"
    },
    "CREATE_FLOW": {
      "CHANNEL": {
        "TITLE": "Choose Channel",
        "BODY": "Zgjidhni ofruesin që dëshironi të integroni me chat-in."
      },
      "INBOX": {
        "TITLE": "Create Inbox",
        "BODY": "Authenticate your account and create an inbox."
      },
      "AGENT": {
        "TITLE": "Add Agents",
        "BODY": "Add agents to the created inbox."
      },
      "FINISH": {
        "TITLE": "Voilà!",
        "BODY": "You are all set to go!"
      }
    },
    "ADD": {
      "CHANNEL_NAME": {
        "LABEL": "Inbox Name",
        "PLACEHOLDER": "Enter your inbox name (eg: Acme Inc)",
        "ERROR": "Please enter a valid inbox name"
      },
      "WEBSITE_NAME": {
        "LABEL": "Website Name",
        "PLACEHOLDER": "Enter your website name (eg: Acme Inc)"
      },
      "INTERNAL_NAME": {
        "LABEL": "Emri i brendshëm",
        "PLACEHOLDER": "Emërtoni kutinë hyrëse siç shfaqet në këtë panel",
        "ERROR": "Vendosni një emër të brendshëm unik"
      },
      "FB": {
        "HELP": "PS: Duke u identifikuar, ne marrim qasje vetëm te mesazhet e faqes suaj. Mesazhet tuaja private nuk mund t'i shohim kurrë.",
        "CHOOSE_PAGE": "Choose Page",
        "CHOOSE_PLACEHOLDER": "Select a page from the list",
        "INBOX_NAME": "Inbox Name",
        "ADD_NAME": "Add a name for your inbox",
        "PICK_NAME": "Pick a Name for your Inbox",
        "PICK_A_VALUE": "Pick a value",
        "CREATE_INBOX": "Krijo kutinë hyrëse"
      },
      "INSTAGRAM": {
        "CONTINUE_WITH_INSTAGRAM": "Vazhdo me Instagram",
        "CONNECT_YOUR_INSTAGRAM_PROFILE": "Lidhni profilin tuaj të Instagramit",
        "HELP": "Për të shtuar profilin tuaj të Instagramit si kanal, duhet të vërtetoni profilin tuaj të Instagramit duke klikuar mbi «Vazhdo me Instagram» ",
        "ERROR_MESSAGE": "Ndodhi një gabim gjatë lidhjes me Instagram, provoni përsëri",
        "ERROR_AUTH": "Ndodhi një gabim gjatë lidhjes me Instagram, provoni përsëri",
        "NEW_INBOX_SUGGESTION": "Kjo llogari Instagram ishte lidhur më parë me një kuti tjetër hyrëse dhe tani është kaluar këtu. Të gjitha mesazhet e reja do të shfaqen këtu. Kutia hyrëse e vjetër nuk do të mund të dërgojë apo marrë më mesazhe për këtë llogari.",
        "DUPLICATE_INBOX_BANNER": "Kjo llogari Instagram u kalua te kutia e re hyrëse e kanalit Instagram. Nuk do të mund të dërgoni/merrni më mesazhe Instagram nga kjo kuti hyrëse."
      },
      "TWITTER": {
        "HELP": "To add your Twitter profile as a channel, you need to authenticate your Twitter Profile by clicking on 'Sign in with Twitter' ",
        "ERROR_MESSAGE": "There was an error connecting to Twitter, please try again",
        "TWEETS": {
          "ENABLE": "Create conversations from mentioned Tweets"
        }
      },
      "WEBSITE_CHANNEL": {
        "TITLE": "Website channel",
        "DESC": "Create a channel for your website and start supporting your customers via our website widget.",
        "LOADING_MESSAGE": "Creating Website Support Channel",
        "CHANNEL_AVATAR": {
          "LABEL": "Channel Avatar"
        },
        "CHANNEL_WEBHOOK_URL": {
          "LABEL": "Webhook URL",
          "PLACEHOLDER": "Please enter your Webhook URL",
          "ERROR": "Please enter a valid URL"
        },
        "CHANNEL_DOMAIN": {
          "LABEL": "Website Domain",
          "PLACEHOLDER": "Enter your website domain (eg: acme.com)"
        },
        "CHANNEL_WELCOME_TITLE": {
          "LABEL": "Welcome Heading",
          "PLACEHOLDER": "Hi there !"
        },
        "CHANNEL_WELCOME_TAGLINE": {
          "LABEL": "Welcome Tagline",
          "PLACEHOLDER": "We make it simple to connect with us. Ask us anything, or share your feedback."
        },
        "CHANNEL_GREETING_MESSAGE": {
          "LABEL": "Channel greeting message",
          "PLACEHOLDER": "Acme Inc typically replies in a few hours."
        },
        "CHANNEL_GREETING_TOGGLE": {
          "LABEL": "Enable channel greeting",
          "HELP_TEXT": "Auto-send greeting messages when customers start a conversation and send their first message.",
          "ENABLED": "Enabled",
          "DISABLED": "Disabled"
        },
        "REPLY_TIME": {
          "TITLE": "Set Reply time",
          "IN_A_FEW_MINUTES": "In a few minutes",
          "IN_A_FEW_HOURS": "In a few hours",
          "IN_A_DAY": "In a day",
          "HELP_TEXT": "This reply time will be displayed on the live chat widget"
        },
        "WIDGET_COLOR": {
          "LABEL": "Widget Color",
          "PLACEHOLDER": "Update the widget color used in widget"
        },
        "SUBMIT_BUTTON": "Create inbox",
        "API": {
          "ERROR_MESSAGE": "We were not able to create a website channel, please try again"
        }
      },
      "TWILIO": {
        "TITLE": "Twilio SMS/WhatsApp Channel",
        "DESC": "Integrate Twilio and start supporting your customers via SMS or WhatsApp.",
        "ACCOUNT_SID": {
          "LABEL": "Account SID",
          "PLACEHOLDER": "Please enter your Twilio Account SID",
          "ERROR": "This field is required"
        },
        "API_KEY": {
          "USE_API_KEY": "Use API Key Authentication",
          "LABEL": "API Key SID",
          "PLACEHOLDER": "Please enter your API Key SID",
          "ERROR": "This field is required"
        },
        "API_KEY_SECRET": {
          "LABEL": "API Key Secret",
          "PLACEHOLDER": "Please enter your API Key Secret",
          "ERROR": "This field is required"
        },
        "MESSAGING_SERVICE_SID": {
          "LABEL": "Messaging Service SID",
          "PLACEHOLDER": "Please enter your Twilio Messaging Service SID",
          "ERROR": "This field is required",
          "USE_MESSAGING_SERVICE": "Use a Twilio Messaging Service"
        },
        "CHANNEL_TYPE": {
          "LABEL": "Channel Type",
          "ERROR": "Please select your Channel Type"
        },
        "AUTH_TOKEN": {
          "LABEL": "Auth Token",
          "PLACEHOLDER": "Please enter your Twilio Auth Token",
          "ERROR": "This field is required"
        },
        "CHANNEL_NAME": {
          "LABEL": "Inbox Name",
          "PLACEHOLDER": "Please enter a inbox name",
          "ERROR": "This field is required"
        },
        "PHONE_NUMBER": {
          "LABEL": "Phone Number",
          "PLACEHOLDER": "Please enter the phone number from which message will be sent.",
          "ERROR": "Please provide a valid phone number that starts with a `+` sign and does not contain any spaces."
        },
        "API_CALLBACK": {
          "TITLE": "Callback URL",
          "SUBTITLE": "You have to configure the message callback URL in Twilio with the URL mentioned here."
        },
        "SUBMIT_BUTTON": "Create Twilio Channel",
        "API": {
          "ERROR_MESSAGE": "We were not able to authenticate Twilio credentials, please try again"
        }
      },
      "SMS": {
        "TITLE": "SMS Channel",
        "DESC": "Start supporting your customers via SMS.",
        "PROVIDERS": {
          "LABEL": "API Provider",
          "TWILIO": "Twilio",
          "BANDWIDTH": "Bandwidth",
          "SMS_BRANA": "SMS Brana",
          "DIDWW": "DIDWW"
        },
        "API": {
          "ERROR_MESSAGE": "We were not able to save the SMS channel"
        },
        "BANDWIDTH": {
          "ACCOUNT_ID": {
            "LABEL": "Account ID",
            "PLACEHOLDER": "Please enter your Bandwidth Account ID",
            "ERROR": "This field is required"
          },
          "API_KEY": {
            "LABEL": "API Key",
            "PLACEHOLDER": "Please enter your Bandwidth API Key",
            "ERROR": "This field is required"
          },
          "API_SECRET": {
            "LABEL": "API Secret",
            "PLACEHOLDER": "Please enter your Bandwidth API Secret",
            "ERROR": "This field is required"
          },
          "APPLICATION_ID": {
            "LABEL": "Application ID",
            "PLACEHOLDER": "Please enter your Bandwidth Application ID",
            "ERROR": "This field is required"
          },
          "INBOX_NAME": {
            "LABEL": "Inbox Name",
            "PLACEHOLDER": "Please enter a inbox name",
            "ERROR": "This field is required"
          },
          "PHONE_NUMBER": {
            "LABEL": "Phone number",
            "PLACEHOLDER": "Please enter the phone number from which message will be sent.",
            "ERROR": "Please provide a valid phone number that starts with a `+` sign and does not contain any spaces."
          },
          "SUBMIT_BUTTON": "Create Bandwidth Channel",
          "API": {
            "ERROR_MESSAGE": "We were not able to authenticate Bandwidth credentials, please try again"
          },
          "API_CALLBACK": {
            "TITLE": "Callback URL",
            "SUBTITLE": "You have to configure the message callback URL in Bandwidth with the URL mentioned here."
          }
        },
        "SMS_BRANA": {
          "INBOX_NAME": {
            "LABEL": "Emri i kutisë hyrëse",
            "PLACEHOLDER": "Vendosni një emër për kutinë hyrëse",
            "ERROR": "Kjo fushë është e detyrueshme"
          },
          "PHONE_NUMBER": {
            "LABEL": "Numri i telefonit",
            "PLACEHOLDER": "Vendosni numrin e telefonit nga i cili do të dërgohen mesazhet.",
            "ERROR": "Vendosni një numër telefoni të vlefshëm që fillon me shenjën `+`."
          },
          "SUBMIT_BUTTON": "Krijo kanalin SMS Brana",
          "API": {
            "ERROR_MESSAGE": "Nuk arritëm ta krijojmë kanalin SMS Brana"
          }
        },
        "DIDWW": {
          "INBOX_NAME": {
            "LABEL": "Emri i kutisë hyrëse",
            "PLACEHOLDER": "Vendosni një emër për kutinë hyrëse",
            "ERROR": "Kjo fushë është e detyrueshme"
          },
          "PHONE_NUMBER": {
            "LABEL": "Numri i telefonit",
            "PLACEHOLDER": "Vendosni numrin e telefonit nga i cili do të dërgohen mesazhet.",
            "ERROR": "Vendosni një numër telefoni të vlefshëm që fillon me shenjën `+`."
          },
          "SUBMIT_BUTTON": "Krijo kanalin DIDWW",
          "API": {
            "ERROR_MESSAGE": "Nuk arritëm ta krijojmë kanalin DIDWW"
          }
        }
      },
      "WHATSAPP": {
        "PROVIDERS": {
          "LABEL": "API Provider",
          "WHATSAPP_CLOUD": "WhatsApp Cloud"
        },
        "API_CALLBACK": {
          "SUBTITLE": "You have to configure the webhook URL and the verification token in the Facebook Developer portal with the values shown below.",
          "WEBHOOK_URL": "Webhook URL",
          "WEBHOOK_VERIFICATION_TOKEN": "Webhook Verification Token"
        },
        "EMBEDDED_SIGNUP": {
          "TITLE": "Konfigurim i shpejtë me Meta",
          "DESC": "Do të ridrejtoheni te Meta për t'u identifikuar në llogarinë tuaj WhatsApp Business. Qasja si administrator do ta bëjë konfigurimin më të lehtë dhe më të shpejtë.",
          "BENEFITS": {
            "EASY_SETUP": "Nuk kërkohet konfigurim manual",
            "SECURE_AUTH": "Vërtetim i sigurt i bazuar në OAuth",
            "AUTO_CONFIG": "Konfigurim automatik i webhook-ut dhe i numrit të telefonit"
          },
          "SUBMIT_BUTTON": "Lidhu me WhatsApp Business",
          "AUTH_PROCESSING": "Duke u vërtetuar me Meta",
          "WAITING_FOR_BUSINESS_INFO": "Plotësoni konfigurimin e biznesit në dritaren e Meta...",
          "PROCESSING": "Duke konfiguruar llogarinë tuaj WhatsApp Business",
          "CANCELLED": "Regjistrimi në WhatsApp u anulua",
          "WAITING_FOR_AUTH": "Duke pritur vërtetimin...",
          "INVALID_BUSINESS_DATA": "U morën të dhëna biznesi të pavlefshme nga Facebook. Provoni përsëri.",
          "SIGNUP_ERROR": "Ndodhi një gabim gjatë regjistrimit",
          "SDK_LOAD_ERROR": "Facebook SDK nuk mund të ngarkohej. Ju lutemi provoni përsëri.",
          "AUTH_NOT_COMPLETED": "Vërtetimi nuk u plotësua. Rinisni procesin.",
          "SUCCESS_FALLBACK": "Llogaria WhatsApp Business u konfigurua me sukses",
          "RECONNECTED": "Kanali i WhatsApp u rilidh me sukses"
        },
        "API": {
          "ERROR_MESSAGE": "We were not able to save the WhatsApp channel"
        }
      },
      "API_CHANNEL": {
        "TITLE": "API Channel",
        "DESC": "Integrate with API channel and start supporting your customers.",
        "CHANNEL_NAME": {
          "LABEL": "Channel Name",
          "PLACEHOLDER": "Please enter a channel name",
          "ERROR": "This field is required"
        },
        "WEBHOOK_URL": {
          "LABEL": "Webhook URL",
          "SUBTITLE": "Configure the URL where you want to receive callbacks on events.",
          "PLACEHOLDER": "Webhook URL"
        },
        "SUBMIT_BUTTON": "Create API Channel",
        "API": {
          "ERROR_MESSAGE": "We were not able to save the api channel"
        }
      },
      "SALESFORCE_CHANNEL": {
        "TITLE": "Kanali Salesforce",
        "DESC": "Integrohuni me kanalin Salesforce dhe filloni të mbështesni klientët tuaj.",
        "CHANNEL_NAME": {
          "LABEL": "Emri i kanalit",
          "PLACEHOLDER": "Vendosni një emër për kanalin",
          "ERROR": "Kjo fushë është e detyrueshme"
        },
        "API_BASE_URL": {
          "LABEL": "URL-ja e API-së Salesforce",
          "SUBTITLE": "Konfiguroni URL-në bazë për instancën tuaj të Salesforce.",
          "PLACEHOLDER": "URL-ja e API-së Salesforce"
        },
        "KEY_ID": {
          "LABEL": "ID e çelësit",
          "SUBTITLE": "ID e çelësit për kanalin tuaj Salesforce.",
          "PLACEHOLDER": "ID E ÇELËSIT"
        },
        "SECRET": {
          "LABEL": "Sekreti",
          "SUBTITLE": "Sekreti për kanalin tuaj Salesforce.",
          "PLACEHOLDER": "*****"
        },
        "SUBMIT_BUTTON": "Krijo kanalin Salesforce",
        "API": {
          "ERROR_MESSAGE": "Nuk arritëm ta ruajmë kanalin Salesforce"
        },
        "API_CALLBACK": {
          "TITLE": "URL-ja e webhook-ut",
          "SUBTITLE": "Duhet të konfiguroni URL-në e webhook-ut në Salesforce me URL-në e përmendur këtu."
        },
        "BEARER_TOKEN": {
          "TITLE": "Token Bearer",
          "SUBTITLE": "Përdorni këtë token Bearer për vërtetim kur konfiguroni webhook-un në Salesforce."
        },
        "OVERRIDE_EMAIL_SENDER": {
          "TITLE": "Anulo dërguesin e paracaktuar të email-it",
          "SUBTITLE": "Nëse vendoset, kjo adresë email do të përdoret si dërguesi për të gjitha email-et dalëse në vend të email-it burimor të bisedës.",
          "PLACEHOLDER": "p.sh. support{'@'}example.com"
        }
      },
      "ALLEGRO_CHANNEL": {
        "TITLE": "Kanali Allegro",
        "DESC": "Lidhni një llogari shitësi në Allegro dhe përgjigjuni mesazheve të saj nga qendra e kontaktit.",
        "CHANNEL_NAME": {
          "LABEL": "Emri i kutisë hyrëse",
          "SUBTITLE": "Emri që agjentët shohin për këtë kuti hyrëse.",
          "PLACEHOLDER": "Vendosni një emër për kutinë hyrëse",
          "ERROR": "Kjo fushë është e detyrueshme"
        },
        "SUBMIT_BUTTON": "Hyni me Allegro",
        "API": {
          "ERROR_MESSAGE": "Pati një gabim gjatë lidhjes me Allegro, provoni përsëri"
        },
        "SELLER_LOGIN": {
          "TITLE": "Hyrja në Allegro",
          "SUBTITLE": "Llogaria e shitësit për të cilën kjo kuti hyrëse lexon dhe u përgjigjet mesazheve."
        }
      },
      "KAUFLAND_CHANNEL": {
        "TITLE": "Kanali Kaufland",
        "DESC": "Përgjigjuni mesazheve të tiketave që blerësit ju dërgojnë në tregun Kaufland.",
        "CHANNEL_NAME": {
          "LABEL": "Emri i kanalit",
          "PLACEHOLDER": "Vendosni një emër për kanalin",
          "ERROR": "Kjo fushë është e detyrueshme"
        },
        "CLIENT_KEY": {
          "LABEL": "Client Key",
          "SUBTITLE": "Client Key me 32 karaktere nga faqja e cilësimeve të API-së në llogarinë tuaj të shitësit në Kaufland.",
          "PLACEHOLDER": "çelës me 32 karaktere",
          "ERROR": "Vendosni Client Key me 32 karaktere"
        },
        "SECRET_KEY": {
          "LABEL": "Secret Key",
          "SUBTITLE": "Secret Key me 64 karaktere që i përket Client Key. Kaufland e shfaq një herë dhe nuk kthehet kurrë në këtë faqe.",
          "PLACEHOLDER": "çelës me 64 karaktere",
          "ERROR": "Vendosni Secret Key me 64 karaktere"
        },
        "SUBMIT_BUTTON": "Krijo kanalin Kaufland",
        "API": {
          "ERROR_MESSAGE": "Nuk arritëm ta ruajmë kanalin Kaufland"
        },
        "DISCONNECTED": {
          "TITLE": "E shkëputur",
          "MESSAGE": "Kaufland i refuzoi këta çelësa API. Vendosni përsëri Client Key dhe Secret Key për ta rilidhur këtë kuti hyrëse."
        }
      },
      "EMAIL_CHANNEL": {
        "TITLE": "Email Channel",
        "DESC": "Integrate your email inbox.",
        "CHANNEL_NAME": {
          "LABEL": "Channel Name",
          "PLACEHOLDER": "Please enter a channel name",
          "ERROR": "This field is required"
        },
        "EMAIL": {
          "LABEL": "Email",
          "SUBTITLE": "Provide the email address where your customers send support requests.",
          "PLACEHOLDER": "Email"
        },
        "SUBMIT_BUTTON": "Create Email Channel",
        "API": {
          "ERROR_MESSAGE": "We were not able to save the email channel"
        },
        "FINISH_MESSAGE": "Start forwarding your emails to the following email address."
      },
      "LINE_CHANNEL": {
        "TITLE": "LINE Channel",
        "DESC": "Integrate with LINE channel and start supporting your customers.",
        "CHANNEL_NAME": {
          "LABEL": "Channel Name",
          "PLACEHOLDER": "Please enter a channel name",
          "ERROR": "This field is required"
        },
        "LINE_CHANNEL_ID": {
          "LABEL": "LINE Channel ID",
          "PLACEHOLDER": "LINE Channel ID"
        },
        "LINE_CHANNEL_SECRET": {
          "LABEL": "LINE Channel Secret",
          "PLACEHOLDER": "LINE Channel Secret"
        },
        "LINE_CHANNEL_TOKEN": {
          "LABEL": "LINE Channel Token",
          "PLACEHOLDER": "LINE Channel Token"
        },
        "SUBMIT_BUTTON": "Create LINE Channel",
        "API": {
          "ERROR_MESSAGE": "We were not able to save the LINE channel"
        },
        "API_CALLBACK": {
          "TITLE": "Callback URL",
          "SUBTITLE": "You have to configure the webhook URL in LINE application with the URL mentioned here."
        }
      },
      "TELEGRAM_CHANNEL": {
        "TITLE": "Telegram Channel",
        "DESC": "Integrate with Telegram channel and start supporting your customers.",
        "BOT_TOKEN": {
          "LABEL": "Bot Token",
          "SUBTITLE": "Configure the bot token you have obtained from Telegram BotFather.",
          "PLACEHOLDER": "Bot Token"
        },
        "SUBMIT_BUTTON": "Create Telegram Channel",
        "API": {
          "ERROR_MESSAGE": "We were not able to save the telegram channel"
        }
      },
      "PHONE_CHANNEL": {
        "TITLE": "Thirrje telefonike",
        "DESC": "Konfiguroni cilat thirrje telefonike do të shfaqen në këtë kuti hyrëse.",
        "NAME": {
          "LABEL": "Emri i kutisë hyrëse",
          "SUBTITLE": "Zgjidhni një emër lehtësisht të identifikueshëm."
        },
        "PHONE_NUMBER": {
          "LABEL": "Numri i telefonit",
          "SUBTITLE": "Vendosni numrat e telefonit që i përkasin kësaj kutie hyrëse, mund të shtoni numra të tjerë më vonë.",
          "PLACEHOLDER": "+421123908635"
        },
        "SUBMIT_BUTTON": "Krijo kutinë hyrëse për thirrje telefonike",
        "API": {
          "ERROR_MESSAGE": "Nuk arritëm ta krijojmë kutinë hyrëse"
        }
      },
      "AUTH": {
        "TITLE": "Choose a channel",
        "DESC": "Chat-i mbështet si kanale widget-et e chat-it të drejtpërdrejtë, Facebook Messenger, WhatsApp, email-et etj. Nëse dëshironi të ndërtoni një kanal të personalizuar, mund ta krijoni me kanalin API. Për të filluar, zgjidhni një nga kanalet më poshtë."
      },
      "AGENTS": {
        "TITLE": "Agents",
        "DESC": "Here you can add agents to manage your newly created inbox. Only these selected agents will have access to your inbox. Agents which are not part of this inbox will not be able to see or respond to messages in this inbox when they login. <br> <b>PS:</b> As an administrator, if you need access to all inboxes, you should add yourself as agent to all inboxes that you create.",
        "VALIDATION_ERROR": "Add at least one agent to your new Inbox",
        "PICK_AGENTS": "Pick agents for the inbox"
      },
      "DETAILS": {
        "TITLE": "Inbox Details",
        "DESC": "Nga lista më poshtë, zgjidhni faqen e Facebook që dëshironi të lidhni me chat-in. Mund t'i jepni edhe një emër të personalizuar kutisë suaj hyrëse për identifikim më të mirë."
      },
      "FINISH": {
        "TITLE": "Nailed It!",
        "DESC": "E keni integruar me sukses faqen tuaj të Facebook me chat-in. Herën tjetër kur një klient i shkruan faqes suaj, biseda do të shfaqet automatikisht në kutinë tuaj hyrëse.<br>Ju ofrojmë gjithashtu një skript widget-i që mund ta shtoni lehtë në faqen tuaj të internetit. Pasi të jetë aktiv në faqen tuaj, klientët mund t'ju shkruajnë direkt nga faqja juaj pa ndihmën e ndonjë mjeti të jashtëm dhe biseda do të shfaqet pikërisht këtu, në chat.<br>Bukur, apo jo? Epo, të paktën përpiqemi :)"
      },
      "EMAIL_PROVIDER": {
        "TITLE": "Select your email provider",
        "DESCRIPTION": "Select an email provider from the list below. If you don't see your email provider in the list, you can select the other provider option and provide the IMAP and SMTP Credentials."
      },
      "MICROSOFT": {
        "TITLE": "Microsoft Email",
        "DESCRIPTION": "Click on the Sign in with Microsoft button to get started. You will redirected to the email sign in page. Once you accept the requested permissions, you would be redirected back to the inbox creation step.",
        "EMAIL_PLACEHOLDER": "Enter email address",
        "SIGN_IN": "Sign in with Microsoft",
        "ERROR_MESSAGE": "There was an error connecting to Microsoft, please try again"
      },
      "GOOGLE": {
        "TITLE": "Google Email",
        "DESCRIPTION": "Click on the Sign in with Google button to get started. You will redirected to the email sign in page. Once you accept the requested permissions, you would be redirected back to the inbox creation step.",
        "SIGN_IN": "Sign in with Google",
        "EMAIL_PLACEHOLDER": "Enter email address",
        "ERROR_MESSAGE": "There was an error connecting to Google, please try again"
      }
    },
    "DETAILS": {
      "LOADING_FB": "Authenticating you with Facebook...",
      "ERROR_FB_LOADING": "Error loading Facebook SDK. Please disable any ad-blockers and try again from a different browser.",
      "ERROR_FB_AUTH": "Something went wrong, Please refresh page...",
      "ERROR_FB_UNAUTHORIZED": "You're not authorized to perform this action. ",
      "ERROR_FB_UNAUTHORIZED_HELP": "Please ensure you have access to the Facebook page with full control. You can read more about Facebook roles <a href=\" https://www.facebook.com/help/187316341316631\">here</a>.",
      "ERROR_CHANNEL_CREATION": "Nuk arritëm ta krijojmë kutinë hyrëse. Provoni përsëri.",
      "CREATING_CHANNEL": "Creating your Inbox...",
      "TITLE": "Configure Inbox Details",
      "DESC": ""
    },
    "AGENTS": {
      "BUTTON_TEXT": "Add agents",
      "ADD_AGENTS": "Adding Agents to your Inbox..."
    },
    "FINISH": {
      "TITLE": "Your Inbox is ready!",
      "MESSAGE": "You can now engage with your customers through your new Channel. Happy supporting",
      "BUTTON_TEXT": "Take me there",
      "MORE_SETTINGS": "More settings",
      "WEBSITE_SUCCESS": "You have successfully finished creating a website channel. Copy the code shown below and paste it on your website. Next time a customer use the live chat, the conversation will automatically appear on your inbox."
    },
    "REAUTH": "Reauthorize",
    "VIEW": "View",
    "EDIT": {
      "API": {
        "SUCCESS_MESSAGE": "Inbox settings updated successfully",
        "AUTO_ASSIGNMENT_SUCCESS_MESSAGE": "Auto assignment updated successfully",
        "ERROR_MESSAGE": "We couldn't update inbox settings. Please try again later."
      },
      "EMAIL_COLLECT_BOX": {
        "ENABLED": "Enabled",
        "DISABLED": "Disabled"
      },
      "ENABLE_CSAT": {
        "ENABLED": "Enabled",
        "DISABLED": "Disabled"
      },
      "ENABLE_CSAT_ON_EACH_MESSAGE": {
        "ENABLED": "Aktivizuar",
        "DISABLED": "Çaktivizuar"
      },
      "SENDER_NAME_SECTION": {
        "TITLE": "Sender name",
        "SUB_TEXT": "Select the name shown to your customer when they receive emails from your agents.",
        "FOR_EG": "For eg:",
        "FRIENDLY": {
          "TITLE": "Friendly",
          "FROM": "form",
          "SUBTITLE": "Add the name of the agent who sent the reply in the sender name to make it friendly."
        },
        "PROFESSIONAL": {
          "TITLE": "Professional",
          "SUBTITLE": "Use only the configured business name as the sender name in the email header."
        },
        "BUSINESS_NAME": {
          "BUTTON_TEXT": "+ Configure your business name",
          "PLACEHOLDER": "Enter your business name",
          "SAVE_BUTTON_TEXT": "Save"
        }
      },
      "ALLOW_MESSAGES_AFTER_RESOLVED": {
        "ENABLED": "Enabled",
        "DISABLED": "Disabled"
      },
      "ENABLE_CONTINUITY_VIA_EMAIL": {
        "ENABLED": "Enabled",
        "DISABLED": "Disabled"
      },
      "RESPOND_FROM_EMAIL": {
        "NONE": "Asnjë"
      },
      "LOCK_TO_SINGLE_CONVERSATION": {
        "ENABLED": "Enabled",
        "DISABLED": "Disabled"
      },
      "ENABLE_HMAC": {
        "LABEL": "Enable"
      },
      "FORCE_NEW_CONVERSATION_PER_LOAD": {
        "ENABLED": "Aktivizuar",
        "DISABLED": "Çaktivizuar"
      },
      "NEW_CONVERSATION_FORGETS_CONTACT": {
        "ENABLED": "Aktivizuar",
        "DISABLED": "Çaktivizuar"
      },
      "ENABLE_EMAIL_FETCHING": {
        "LABEL": "Aktivizo sinkronizimin e email-eve hyrëse"
      },
      "ENABLE_CUSTOM_EMAIL": {
        "LABEL": "Aktivizo domenin e personalizuar të email-it (shërbim me pagesë)."
      },
      "ENABLE_FACEBOOK_COMMENTS": {
        "LABEL": "Aktivizo përpunimin e komenteve në Facebook"
      },
      "SIGNATURE": {
        "TITLE": "Nënshkrim HTML",
        "SUB_TEXT": "Ky nënshkrim do t'i shtohet fundit të çdo mesazhi të dërguar nga kjo kuti hyrëse.",
        "HTML_CONTENT": "Kodi HTML",
        "HTML_CONTENT_HELP": "{'{{'}name{'}}'} do të zëvendësohet me emrin e agjentit.\n{'{{'}email{'}}'} do të zëvendësohet me adresën email të agjentit që dërgoi email-in.\n{'{{'}position{'}}'} do të zëvendësohet me pozicionin e agjentit.\n{'{{'}custom_line{'}}'} do të zëvendësohet me rreshtin e personalizuar të agjentit.\n{'{{'}email_signature_picture{'}}'} do të zëvendësohet me URL-në e fotos së nënshkrimit email të agjentit (jo një etiketë figure) — përdoreni si burim figure (atributi src i etiketës img).",
        "PREVIEW": "Parapamje"
      },
      "COUNTRY_SIGNATURES": {
        "TITLE": "Nënshkrime sipas shtetit",
        "SUB_TEXT": "Përgjigjja merr nënshkrimin sipas shtetit të blerësit.",
        "HELP": "Përgjigjja nënshkruhet sipas shtetit të bisedës: sipas dyqanit Kaufland, sipas tregut të porosisë Allegro, përndryshe sipas gjuhës në të cilën shkruan blerësi. Kur shteti nuk njihet ose nuk ka nënshkrim këtu, përdoret nënshkrimi HTML më sipër. Tregjet ndalojnë lidhjet drejt faqes tuaj dhe të dhënat e kontaktit, ndaj shkruani vetëm një përshëndetje dhe {'{{'}name{'}}'}.",
        "EMPTY": "Nuk keni ende nënshkrime sipas shtetit, ndaj përgjigjet përdorin nënshkrimin HTML më sipër.",
        "COUNTRY": "Zgjidhni një shtet",
        "ADD": "Shto nënshkrim për shtetin",
        "REMOVE": "Hiq"
      },
      "PHONE_DIALING_PREFIX": {
        "LABEL": "Prefiksi i numrit të telefonit",
        "PLACEHOLDER": "Vendosni prefiksin për drejtimin e saktë të thirrjeve (p.sh., *99)",
        "HELP_TEXT": "Ky prefiks do t'u shtohet automatikisht numrave të telefonit të kontakteve kur thirrni nga kjo kuti hyrëse."
      },
      "RESOLVE_LATER_TEXT": {
        "LABEL": "Teksti i butonit «Zgjidhe më vonë»",
        "PLACEHOLDER": "p.sh. Këtë temë do ta zgjidhim me email. Tani dua të pyes për diçka tjetër.",
        "HELP_TEXT": "Teksti i butonit në widget me të cilin vizitori e lë temën aktuale dhe pyet për diçka tjetër. Nëse e lini bosh, përdoret teksti i parazgjedhur në gjuhën e vizitorit."
      },
      "AUTO_SNOOZE_MINUTES": {
        "LABEL": "Shtyj automatikisht thirrjet e humbura për X minuta",
        "PLACEHOLDER": "0",
        "HELP_TEXT": "Shtyn automatikisht thirrjet e humbura për numrin e specifikuar të minutave. Lëreni bosh ose 0 për ta çaktivizuar."
      },
      "AUTO_RESOLVE_AFTER_FAILED_ATTEMPTS": {
        "LABEL": "Zgjidh një thirrje të humbur pas X thirrjeve kthyese të pasuksesshme",
        "PLACEHOLDER": "0",
        "HELP_TEXT": "Pasi një thirrje e humbur është rithirrur X herë pa u përgjigjur klienti, ajo zgjidhet automatikisht dhe shtohet një shënim privat. Lëreni bosh ose 0 për ta çaktivizuar."
      },
      "QUESTION_SUGGESTIONS": {
        "TITLE": "Sugjerime pyetjesh",
        "SUB_TEXT": "Konfiguroni pyetje të paracaktuara që klientët mund t'i përdorin për të komunikuar me agjentët tuaj.",
        "QUESTIONS_LABEL": "Pyetje",
        "ADD_QUESTION": "Shto pyetje",
        "REMOVE": "Hiq",
        "QUESTION_TEXT": "Teksti i shfaqur në flluskë.",
        "QUESTION_TEXT_PLACEHOLDER": "E detyrueshme",
        "QUESTION_PAYLOAD": "Teksti i dërguar kur klikohet.",
        "QUESTION_PAYLOAD_PLACEHOLDER": "Opsionale",
        "NO_BOT_MESSAGE": "Për të gjeneruar sugjerime shtesë me IA, lidhni një bot.",
        "BOT_CONNECTED_MESSAGE": "Sugjerimet e pyetjeve me IA nga boti mund të aktivizohen në",
        "BOT_SETTINGS_LINK": "cilësimet e tij"
      },
      "ALTERNATIVE_EMAILS": {
        "TITLE": "Email-e alternative",
        "SUB_TEXT": "Adresa shtesë që kjo kuti hyrëse duhet t'i trajtojë si të vetat kur merr postë të përcjellë.",
        "PLACEHOLDER": "alias{'@'}example.com",
        "ADD": "Shto",
        "REMOVE": "Hiq",
        "EMPTY": "Nuk ka email-e alternative të konfiguruara.",
        "HELP_TEXT": "Kur një email mbërrin me një nga këto adresa si marrës, përgjigjet do të dërgohen me të njëjtën adresë si dërgues. Sigurohuni që serveri juaj dalës SMTP lejon dërgimin nga këto adresa.",
        "SIGNATURE_LABEL": "Nënshkrimi",
        "PRIMARY_SIGNATURE": "Parësor (parazgjedhje)"
      },
      "ADDITIONAL_SIGNATURES": {
        "TITLE": "Nënshkrime shtesë",
        "SUB_TEXT": "Përcaktoni këtu nënshkrime shtesë, pastaj caktojini ato te email-et alternative më poshtë.",
        "OPTION": "Nënshkrimi {number}",
        "ADD": "Shto nënshkrim",
        "REMOVE": "Hiq",
        "HELP_TEXT": "Kur një përgjigje dërgohet nga një email alternativ, përdoret nënshkrimi i caktuar për të në vend të nënshkrimit të kutisë hyrëse. Email-et alternative të lëna te «Parësor (parazgjedhje)» kthehen te nënshkrimi i kutisë hyrëse."
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Delete",
      "AVATAR_DELETE_BUTTON_TEXT": "Delete Avatar",
      "DELETE_REQUESTED_TOOLTIP": "Kjo kuti hyrëse është shënuar për fshirje",
      "RESTORE_BUTTON_TEXT": "Rikthe",
      "CONFIRM": {
        "TITLE": "Confirm Deletion",
        "MESSAGE": "Are you sure to delete ",
        "PLACE_HOLDER": "Please type {inboxName} to confirm",
        "YES": "Yes, Delete ",
        "NO": "No, Keep "
      },
      "API": {
        "SUCCESS_MESSAGE": "Inbox deleted successfully",
        "MARKED_FOR_DELETION_MESSAGE": "Kutia hyrëse u shënua për fshirje",
        "RESTORE_SUCCESS_MESSAGE": "Kutia hyrëse u rikthye me sukses",
        "ERROR_MESSAGE": "Could not delete inbox. Please try again later.",
        "RESTORE_ERROR_MESSAGE": "Kutia hyrëse nuk mund të rikthehej. Provoni përsëri më vonë.",
        "AVATAR_SUCCESS_MESSAGE": "Inbox avatar deleted successfully",
        "AVATAR_ERROR_MESSAGE": "Could not delete the inbox avatar. Please try again later."
      }
    },
    "TABS": {
      "SETTINGS": "Settings",
      "COLLABORATORS": "Collaborators",
      "AUTOMATIC_PRIORITY": "Prioriteti automatik",
      "AUTOMATIC_LABELING": "Etiketimi automatik",
      "CONFIGURATION": "Configuration",
      "CAMPAIGN": "Campaigns",
      "PRE_CHAT_FORM": "Pre Chat Form",
      "BUSINESS_HOURS": "Business Hours",
      "WIDGET_BUILDER": "Widget Builder",
      "BOT_CONFIGURATION": "Bot Configuration",
      "SLA": "SLA"
    },
    "SETTINGS": "Settings",
    "FEATURES": {
      "LABEL": "Features",
      "DISPLAY_FILE_PICKER": "Display file picker on the widget",
      "DISPLAY_EMOJI_PICKER": "Display emoji picker on the widget",
      "ALLOW_END_CONVERSATION": "Allow users to end conversation from the widget",
      "SHOW_START_NEW_CONVERSATION_BUTTON": "Shfaq butonin 'Fillo një bisedë të re' në kreun e widget-it",
      "HIDE_INPUT_UNDER_START_NEW_CONVERSATION_BUTTON": "Hide input field when start new conversation button is shown",
      "SHOW_HANDOFF_BUTTON": "Shfaq butonin 'Transfero te operatori' në kreun e widget-it",
      "AUTO_CLOSE_OLD": "Shëno të gjitha thirrjet e kaluara nga i njëjti numër si të zgjidhura pasi njëra të zgjidhet",
      "AUTO_ASSIGN_MISSED_ON_OUTGOING": "Cakto automatikisht thirrjet e humbura kur bëhet një thirrje dalëse",
      "USE_INBOX_AVATAR_FOR_BOT": "Use inbox name and avatar for the bot",
      "ALLOW_OFFLINE_REPLY": "Lejo agjentët të dërgojnë mesazhe kur kontakti është jashtë linje dhe vazhdimësia me email nuk është e disponueshme"
    },
    "SETTINGS_POPUP": {
      "MESSENGER_HEADING": "Messenger Script",
      "MESSENGER_SUB_HEAD": "Place this button inside your body tag",
      "INBOX_AGENTS": "Agents",
      "INBOX_TEAMS": "Ekipe",
      "INBOX_COOPERATORS": "Bashkëpunëtorë",
      "SELECT_PLACEHOLDER": "Zgjidh",
      "AGENTS_OR_TEAMS_INFO": "Mund të caktoni ose agjentë ose ekipe – jo të dyja njëkohësisht.",
      "INBOX_AGENTS_SUB_TEXT": "Add or remove agents from this inbox",
      "AGENT_ASSIGNMENT": "Conversation Assignment",
      "AGENT_ASSIGNMENT_SUB_TEXT": "Update conversation assignment settings",
      "UPDATE": "Update",
      "ENABLE_EMAIL_COLLECT_BOX": "Enable email collect box",
      "ENABLE_EMAIL_COLLECT_BOX_SUB_TEXT": "Enable or disable email collect box on new conversation",
      "AUTO_ASSIGNMENT": "Enable auto assignment",
      "ENABLE_CSAT": "Enable CSAT",
      "ENABLE_CSAT_ON_EACH_MESSAGE": "Aktivizo CSAT për çdo mesazh",
      "SENDER_NAME_SECTION": "Enable Agent Name in Email",
      "ENABLE_CSAT_SUB_TEXT": "Enable/Disable CSAT(Customer satisfaction) survey after resolving a conversation",
      "ENABLE_CSAT_ON_EACH_MESSAGE_SUB_TEXT": "Aktivizo/Çaktivizo anketën CSAT për çdo mesazh të dërguar nga agjentët",
      "SENDER_NAME_SECTION_TEXT": "Enable/Disable showing Agent's name in email, if disabled it will show business name",
      "ENABLE_CONTINUITY_VIA_EMAIL": "Enable conversation continuity via email",
      "ENABLE_CONTINUITY_VIA_EMAIL_SUB_TEXT": "Conversations will continue over email if the contact email address is available.",
      "RESPOND_FROM_EMAIL": "Përgjigju nga email-i",
      "RESPOND_FROM_EMAIL_SUB_TEXT_WEBWIDGET": "Email-et drejtuar klientit — si përgjigjet ashtu edhe transkriptet e bisedës — dërgohen duke përdorur cilësimet SMTP të kutisë hyrëse email të zgjedhur, nga adresa e zgjedhur (adresa e vet e kutisë ose një nga aliaset e saj), ndërsa përgjigjet e klientit vijnë përsëri përmes adresës së saj IMAP.",
      "RESPOND_FROM_EMAIL_SUB_TEXT_OTHER": "Transkriptet e bisedës dërgohen duke përdorur cilësimet SMTP të kutisë hyrëse email të zgjedhur, nga adresa e zgjedhur (adresa e vet e kutisë ose një nga aliaset e saj), ndërsa përgjigjet vijnë përsëri përmes adresës së saj IMAP.",
      "SHOW_WELCOME_SCREEN": "Shfaq ekranin e mirëseardhjes",
      "SHOW_WELCOME_SCREEN_TOOLTIP": "Shfaq ekranin e mirëseardhjes kur hapet widget-i. Nëse çaktivizohet, widget-i do të kalojë direkt te pamja e bisedës.",
      "AUTO_CLOSE_PENDING": "Zgjidh automatikisht bisedat me IA pas (orë)",
      "AUTO_CLOSE_PENDING_SUB_TEXT": "Zgjidh automatikisht bisedat me IA pas X orësh mosveprimtarie.",
      "LOCK_TO_SINGLE_CONVERSATION": "Lock to single conversation",
      "LOCK_TO_SINGLE_CONVERSATION_SUB_TEXT": "Enable or disable multiple conversations for the same contact in this inbox",
      "INBOX_UPDATE_TITLE": "Inbox Settings",
      "INBOX_UPDATE_SUB_TEXT": "Update your inbox settings",
      "AUTO_ASSIGNMENT_SUB_TEXT": "Enable or disable the automatic assignment of new conversations to the agents added to this inbox.",
      "HMAC_VERIFICATION": "User Identity Validation",
      "HMAC_DESCRIPTION": "With this key you can generate a secret token that can be used to verify the identity of your users.",
      "HMAC_ROTATE": {
        "BUTTON": "Ndërro çelësin",
        "TITLE": "Të ndërrohet çelësi sekret?",
        "WARNING": "Çelësi aktual revokohet menjëherë pasi ta ndërroni.",
        "WARNING_DETAIL": "Nuk ka periudhë mbivendosjeje dhe nuk mund të rikthehet.",
        "IMPACT": "Serverët tuaj duhet t'i nënshkruajnë përdoruesit me çelësin e ri. Kushdo që është ende i nënshkruar me atë të vjetrin, dështon në verifikim. Nëse kërkohet verifikimi i identitetit, ata nuk mund të fillojnë një bisedë.",
        "CONFIRM": "Ndërro çelësin",
        "CANCEL": "Anulo",
        "SUCCESS": "Çelësi sekret u ndërrua me sukses",
        "ERROR": "Nuk u arrit të ndërrohej çelësi sekret, provoni përsëri"
      },
      "HMAC_LINK_TO_DOCS": "You can read more here.",
      "HMAC_MANDATORY_VERIFICATION": "Enforce User Identity Validation",
      "HMAC_MANDATORY_DESCRIPTION": "If enabled, requests that cannot be verified will be rejected.",
      "FORCE_NEW_CONVERSATION_PER_LOAD_TITLE": "Detyro një bisedë të re në çdo ngarkim të widget-it",
      "FORCE_NEW_CONVERSATION_PER_LOAD_SUBTITLE": "Nëse aktivizohet, hapja e widget-it në një skedë ose dritare të re fillon një bisedë të re.",
      "NEW_CONVERSATION_FORGETS_CONTACT_TITLE": "Harro kontaktin kur fillon një bisedë e re",
      "NEW_CONVERSATION_FORGETS_CONTACT_SUBTITLE": "Nëse çaktivizohet, një bisedë e re e filluar nga widget-i ruan kontaktin e mëparshëm.",
      "INBOX_IDENTIFIER": "Inbox Identifier",
      "INBOX_IDENTIFIER_SUB_TEXT": "Use the `inbox_identifier` token shown here to authentication your API clients.",
      "FORWARD_EMAIL_TITLE": "Forward to Email",
      "FORWARD_EMAIL_SUB_TEXT": "Start forwarding your emails to the following email address.",
      "EMAIL_FETCHING_ENABLED_TITLE": "Sinkronizimi i email-it",
      "EMAIL_FETCHING_ENABLED_DESCRIPTION": "Aktivizo sinkronizimin dhe shkarkimin automatik të email-eve hyrëse nga kjo kuti hyrëse",
      "CUSTOM_EMAIL_ENABLED_TITLE": "Domen i personalizuar email-i",
      "CUSTOM_EMAIL_ENABLED_DESCRIPTION": "Aktivizo për të përdorur një domen të personalizuar email-i për email-et dalëse",
      "CUSTOM_EMAIL_ENABLED_LINK_TO_DOCS": "Mund të lexoni më shumë këtu.",
      "FACEBOOK_COMMENTS_TITLE": "Komentet në Facebook",
      "ALLOW_MESSAGES_AFTER_RESOLVED": "Allow messages after conversation resolved",
      "ALLOW_MESSAGES_AFTER_RESOLVED_SUB_TEXT": "Allow the end-users to send messages even after the conversation is resolved.",
      "WIDGET_STATUS_LABEL": "Statusi i widget-it",
      "WIDGET_STATUS_ENABLED": "Aktivizuar",
      "WIDGET_STATUS_BUSINESS_HOURS": "Aktivizuar gjatë orarit të punës",
      "WIDGET_STATUS_DISABLED": "Çaktivizuar",
      "WIDGET_STATUS_HELP_TEXT": "Kontrolloni kur widget-i u shfaqet vizitorëve në faqen tuaj të internetit",
      "UPDATE_PRE_CHAT_FORM_SETTINGS": "Update Pre Chat Form Settings",
      "EXPLICIT_CSAT_LOCALE": "Gjuha e anketës CSAT dhe e email-it",
      "EXPLICIT_CSAT_LOCALE_SUB_TEXT": "Zgjidhni gjuhën për të gjitha email-et e klientëve, përfshirë anketat CSAT, transkriptet e bisedës dhe njoftimet me email",
      "EXPLICIT_CSAT_LOCALE_INHERIT": "Trashëgoje nga llogaria",
      "WHATSAPP_CONNECTION": {
        "TITLE": "Lidhja me WhatsApp",
        "SUBTITLE": "Si është lidhur kjo kuti me WhatsApp.",
        "PROVIDER": "Ofruesi",
        "PROVIDER_VALUE": "WhatsApp Cloud API (Meta)",
        "EMBEDDED_SIGNUP": "Lidhur përmes regjistrimit të integruar të Meta",
        "STATUS": "Statusi",
        "CONNECTED": "I lidhur",
        "RECONNECT_HINT": "Klikoni Rilidhu te njoftimi më sipër.",
        "PHONE_NUMBER": "Numri i telefonit",
        "BUSINESS_ACCOUNT": "ID e llogarisë WhatsApp Business",
        "OPEN_MANAGER": "Hape në WhatsApp Manager",
        "PHONE_NUMBER_ID": "ID e numrit të telefonit",
        "TEMPLATES": "Shabllonet e mesazheve",
        "TEMPLATES_COUNT": "{approved} nga {total} të miratuara",
        "TEMPLATES_SYNCED": "Sinkronizuar së fundi më {date}",
        "TEMPLATES_NOT_SYNCED": "Ende të pasinkronizuara",
        "MANAGE_TEMPLATES": "Menaxho shabllonet"
      }
    },
    "HELP_CENTER": {
      "LABEL": "Help Center",
      "PLACEHOLDER": "Select Help Center",
      "SELECT_PLACEHOLDER": "Select Help Center",
      "REMOVE": "Remove Help Center",
      "SUB_TEXT": "Attach a Help Center with the inbox"
    },
    "AUTO_ASSIGNMENT": {
      "MAX_ASSIGNMENT_LIMIT": "Auto assignment limit",
      "MAX_ASSIGNMENT_LIMIT_RANGE_ERROR": "Please enter a value greater than 0",
      "MAX_ASSIGNMENT_LIMIT_SUB_TEXT": "Limit the maximum number of conversations from this inbox that can be auto assigned to an agent"
    },
    "SLA": {
      "TITLE": "Politikat SLA",
      "SUB_TEXT": "Konfiguroni kohët e përgjigjes dhe zgjidhjes së SLA-së për çdo nivel prioriteti të bisedës.",
      "LOADING": "Duke ngarkuar politikat SLA...",
      "FIELDS": {
        "ACTIVE": "Aktive",
        "TICKET_PRIORITY": "Prioriteti i tiketës",
        "FIRST_RESPONSE_TIME": "Koha e përgjigjes së parë",
        "EVERY_RESPONSE_TIME": "Koha e çdo përgjigjeje",
        "RESOLUTION_TIME": "Koha e zgjidhjes",
        "PLACEHOLDER": "p.sh. 1h 30m"
      },
      "API": {
        "SUCCESS_MESSAGE": "Politikat SLA u përditësuan me sukses.",
        "ERROR_MESSAGE": "Politikat SLA nuk mund të përditësoheshin. Provoni përsëri."
      }
    },
    "AUTOMATIC_PRIORITY": {
      "TITLE": "Prioriteti automatik",
      "SUB_TEXT": "Konfiguroni caktimin automatik të prioritetit bazuar në përmbajtjen e bisedës.",
      "BILLING_DISCLAIMER": {
        "TITLE": "Njoftim faturimi",
        "MESSAGE": "Çdo vlerësim prioriteti do të shkaktojë një kosto. Shqyrtoni detajet e planit tuaj për informacion mbi çmimet."
      },
      "MODE": {
        "OFF": "Joaktiv",
        "ALL_MESSAGES": "Aktiv për të gjitha mesazhet hyrëse",
        "FIRST_MESSAGE": "Aktiv vetëm për mesazhin e parë hyrës"
      },
      "PRIORITY_LEVELS": {
        "TITLE": "Konfigurimi i niveleve të prioritetit",
        "SUB_TEXT": "Konfiguroni cilat nivele prioriteti duhen aktivizuar dhe përshkrimet e tyre. Jepni kritere të qarta që IA të përcaktojë kur duhet caktuar ky prioritet."
      },
      "DESCRIPTION_LABEL": "Përshkrimi",
      "DESCRIPTION_PLACEHOLDER": "Përshkruani bisedat që duhen shënuar me prioritet {priority}",
      "SET_AS_DEFAULT": "Vendos si prioritet të parazgjedhur",
      "MULTIPLE_DEFAULTS_WARNING": "Vetëm një nivel prioriteti duhet të jetë i parazgjedhur. Hiqni shenjën nga parazgjedhjet e tjera."
    },
    "AUTOMATIC_LABELING": {
      "TITLE": "Etiketimi automatik",
      "SUB_TEXT": "Konfiguroni caktimin automatik të etiketave bazuar në përmbajtjen e bisedës.",
      "BILLING_DISCLAIMER": {
        "TITLE": "Njoftim faturimi",
        "MESSAGE": "Çdo vlerësim etiketimi do të shkaktojë një kosto. Shqyrtoni detajet e planit tuaj për informacion mbi çmimet."
      },
      "MODE": {
        "OFF": "Joaktiv",
        "CONVERSATION_OPEN": "Kur hapet biseda",
        "CONVERSATION_CLOSE": "Kur mbyllet biseda",
        "ALL_MESSAGES": "Në çdo mesazh – pavarësisht gjendjes",
        "FIRST_MESSAGE": "Në mesazhin e parë – pavarësisht gjendjes"
      },
      "LABEL_CONFIGURATION": {
        "TITLE": "Konfigurimi i etiketave",
        "SUB_TEXT": "Konfiguroni cilat etiketa duhen bërë të disponueshme për caktim automatik dhe përshkrimet e tyre. Jepni kritere të qarta që IA të përcaktojë kur duhet vendosur kjo etiketë."
      },
      "DESCRIPTION_LABEL": "Përshkrimi",
      "DESCRIPTION_PLACEHOLDER": "Përshkruani bisedat që duhen etiketuar si {label}. Nëse e lini bosh, do të përdoret përshkrimi i etiketës.",
      "NO_LABELS_MESSAGE": "Nuk u gjetën etiketa. Krijoni etiketa më parë për të aktivizuar etiketimin automatik.",
      "CREATE_LABELS_LINK": "Krijo etiketa"
    },
    "FACEBOOK_REAUTHORIZE": {
      "TITLE": "Reauthorize",
      "SUBTITLE": "Your Facebook connection has expired, please reconnect your Facebook page to continue services",
      "MESSAGE_SUCCESS": "Reconnection successful",
      "MESSAGE_ERROR": "There was an error, please try again"
    },
    "PRE_CHAT_FORM": {
      "DESCRIPTION": "Pre chat forms enable you to capture user information before they start conversation with you.",
      "SET_FIELDS": "Pre chat form fields",
      "SET_FIELDS_HEADER": {
        "FIELDS": "Fields",
        "LABEL": "Label",
        "PLACE_HOLDER": "Placeholder",
        "KEY": "Key",
        "TYPE": "Type",
        "REQUIRED": "Required"
      },
      "ENABLE": {
        "LABEL": "Enable pre chat form",
        "OPTIONS": {
          "ENABLED": "Yes",
          "DISABLED": "No"
        }
      },
      "PRE_CHAT_MESSAGE": {
        "LABEL": "Pre chat message",
        "PLACEHOLDER": "This message would be visible to the users along with the form"
      },
      "REQUIRE_EMAIL": {
        "LABEL": "Visitors should provide their name and email address before starting the chat"
      }
    },
    "BUSINESS_HOURS": {
      "TITLE": "Set your availability",
      "SUBTITLE": "Set your availability on your livechat widget",
      "WEEKLY_TITLE": "Set your weekly hours",
      "TIMEZONE_LABEL": "Select timezone",
      "UPDATE": "Update business hours settings",
      "TOGGLE_AVAILABILITY": "Enable business availability for this inbox",
      "UNAVAILABLE_MESSAGE_LABEL": "Unavailable message for visitors",
      "TOGGLE_HELP": "Enabling business availability will show the available hours on live chat widget even if all the agents are offline. Outside available hours visitors can be warned with a message and a pre-chat form.",
      "DAY": {
        "ENABLE": "Enable availability for this day",
        "UNAVAILABLE": "Unavailable",
        "HOURS": "hours",
        "VALIDATION_ERROR": "Starting time should be before closing time.",
        "CHOOSE": "Choose"
      },
      "ALL_DAY": "All-Day",
      "SAVE_TO_ALL": "Ruaj në të gjitha kutitë hyrëse",
      "SAVE_TO_ALL_TITLE": "Kopjo orarin e punës",
      "SAVE_TO_ALL_CONFIRM": "Cilësimet nga ky formular (çelësi i disponueshmërisë, mesazhi i jashtë-zyrës, zona kohore dhe orari i punës) do të kopjohen te të gjitha kutitë e tjera hyrëse, përveç kutive hyrëse për email dhe telefon. Jeni i sigurt që doni të vazhdoni?",
      "SAVE_TO_ALL_CANCEL": "Anulo",
      "SAVE_TO_ALL_YES": "Po, kopjo tek të gjitha",
      "SAVE_TO_ALL_SUCCESS": "Orari i punës u kopjua me sukses te të gjitha kutitë e tjera hyrëse",
      "SAVE_TO_ALL_ERROR": "Kopjimi i orarit të punës te kutitë e tjera hyrëse dështoi"
    },
    "PHONE": {
      "TITLE": "Cilësimet e telefonit",
      "SUBTITLE": "Konfiguroni cilat thirrje do të shfaqen në këtë kuti hyrëse.",
      "UPDATE": "Ruaj cilësimet",
      "EDIT": {
        "SUCCESS_MESSAGE": "Cilësimet e telefonit u përditësuan"
      },
      "PHONE_NUMBERS": {
        "LABEL": "Numrat e telefonit",
        "PLACEHOLDER": "+145123908635"
      }
    },
    "IMAP": {
      "TITLE": "IMAP",
      "SUBTITLE": "Set your IMAP details",
      "NOTE_TEXT": "To enable SMTP, please configure IMAP.",
      "UPDATE": "Update IMAP settings",
      "TOGGLE_AVAILABILITY": "Enable IMAP configuration for this inbox",
      "TOGGLE_HELP": "Enabling IMAP will help the user to receive email",
      "EDIT": {
        "SUCCESS_MESSAGE": "IMAP settings updated successfully",
        "ERROR_MESSAGE": "Unable to update IMAP settings"
      },
      "ADDRESS": {
        "LABEL": "Address",
        "PLACE_HOLDER": "Address (Eg: imap.gmail.com)"
      },
      "PORT": {
        "LABEL": "Port",
        "PLACE_HOLDER": "Port"
      },
      "LOGIN": {
        "LABEL": "Login",
        "PLACE_HOLDER": "Login"
      },
      "PASSWORD": {
        "LABEL": "Password",
        "PLACE_HOLDER": "Password"
      },
      "ENABLE_SSL": "Enable SSL"
    },
    "MICROSOFT": {
      "TITLE": "Microsoft",
      "SUBTITLE": "Reauthorize your MICROSOFT account"
    },
    "SMTP": {
      "TITLE": "SMTP",
      "SUBTITLE": "Set your SMTP details",
      "UPDATE": "Update SMTP settings",
      "TOGGLE_AVAILABILITY": "Enable SMTP configuration for this inbox",
      "TOGGLE_HELP": "Enabling SMTP will help the user to send email",
      "EDIT": {
        "SUCCESS_MESSAGE": "SMTP settings updated successfully",
        "ERROR_MESSAGE": "Unable to update SMTP settings"
      },
      "ADDRESS": {
        "LABEL": "Address",
        "PLACE_HOLDER": "Address (Eg: smtp.gmail.com)"
      },
      "PORT": {
        "LABEL": "Port",
        "PLACE_HOLDER": "Port"
      },
      "LOGIN": {
        "LABEL": "Login",
        "PLACE_HOLDER": "Login"
      },
      "PASSWORD": {
        "LABEL": "Password",
        "PLACE_HOLDER": "Password"
      },
      "DOMAIN": {
        "LABEL": "Domain",
        "PLACE_HOLDER": "Domain"
      },
      "ENCRYPTION": "Encryption",
      "SSL_TLS": "SSL/TLS",
      "START_TLS": "STARTTLS",
      "OPEN_SSL_VERIFY_MODE": "Open SSL Verify Mode",
      "AUTH_MECHANISM": "Authentication"
    },
    "EMAIL_DNS_CHECK": {
      "TITLE": "Dorëzueshmëria e email-eve (DNS)",
      "SUB_TITLE": "Çdo ditë pune i kontrollojmë regjistrimet SPF, DKIM, DMARC dhe MX të {domain}. Kur diçka bën që serverat marrës t'i refuzojnë ose t'i hedhin te spami përgjigjet tuaja, administratorët marrin një email me zgjidhjen.",
      "RUN": "Kryej kontrollin",
      "RUN_SUCCESS": "Kontrolli DNS përfundoi",
      "RUN_ERROR": "Kontrolli DNS nuk mund të kryhej, ju lutemi provoni përsëri",
      "NOT_CHECKED": "Ende nuk është kontrolluar.",
      "CHECKED_AT": "Kontrolli i fundit: {time}.",
      "DNS_UNAVAILABLE": "Kontrolli i fundit nuk mori përgjigje nga serverat e emrave të domenit. Rezultati më poshtë është nga kontrolli i mëparshëm.",
      "SENDER": {
        "SMTP": "Përgjigjet dërgohen përmes {host}.",
        "PLATFORM": "Përgjigjet dërgohen përmes serverave tanë postarë."
      },
      "STATUS": {
        "OK": "Të gjitha regjistrimet janë në rregull",
        "WARNING": "Disa regjistrime mund të jenë më të mira",
        "ERROR": "Përgjigjet mund të mos u arrijnë marrësve",
        "UNKNOWN": "E panjohur"
      },
      "SEVERITY": {
        "ERROR": "Problem",
        "WARNING": "Paralajmërim"
      },
      "FIX": "Rregullojeni me këtë regjistrim DNS:",
      "RECORD_TYPE": "Lloji",
      "RECORD_HOST": "Emri",
      "RECORD_VALUE": "Vlera",
      "ISSUES": {
        "spf_missing": {
          "TITLE": "Mungon regjistrimi SPF",
          "DESCRIPTION": "Domeni nuk tregon cilat serverë mund të dërgojnë email-et e tij. Shumë serverë postarë i trajtojnë atëherë përgjigjet tuaja si spam. Shtoni një regjistrim SPF që lejon {sender}."
        },
        "spf_multiple": {
          "TITLE": "Domeni ka {count} regjistrime SPF",
          "DESCRIPTION": "Një domen mund të ketë vetëm një regjistrim SPF. Me më shumë, serverat marrës e shpërfillin SPF dhe shpesh e refuzojnë postën. Bashkojini në një regjistrim të vetëm."
        },
        "spf_not_authorized": {
          "TITLE": "SPF nuk e lejon serverin që dërgon përgjigjet tuaja",
          "DESCRIPTION": "Përgjigjet tuaja dërgohen përmes {sender}, por regjistrimi SPF i domenit nuk e përfshin. Regjistrimi aktual: {record}"
        },
        "spf_too_many_lookups": {
          "TITLE": "Regjistrimi SPF kërkon shumë kërkesa DNS",
          "DESCRIPTION": "Serverat marrës ndalojnë së kontrolluari SPF pas {limit} kërkesash DNS, por {sender}, përmes të cilit dërgohen përgjigjet tuaja, arrihet vetëm pas {lookups}. Përgjigjet tuaja dështojnë në SPF. Zhvendosni {sender} në fillim të regjistrimit dhe hiqni include-t që domeni nuk i përdor më."
        },
        "spf_lookups_others": {
          "TITLE": "Disa dërgues në regjistrimin SPF janë përtej kufirit të kërkesave",
          "DESCRIPTION": "Regjistrimi SPF kërkon {lookups} kërkesa DNS, serverat marrës ndalojnë pas {limit}. Përgjigjet tuaja përputhen në kohë dhe kalojnë, por posta nga këta dërgues dështon në SPF: {senders}. Hiqni include-t që domeni nuk i përdor më."
        },
        "spf_malformed": {
          "TITLE": "Regjistrimi SPF është i prishur",
          "DESCRIPTION": "Serverat marrës nuk e lexojnë dot regjistrimin SPF të domenit, ndaj ai nuk i mbron përgjigjet tuaja. Problemi është te: {terms}. Zëvendësojeni regjistrimin me versionin e korrigjuar."
        },
        "dkim_missing": {
          "TITLE": "Nënshkrimi DKIM nuk është caktuar",
          "DESCRIPTION": "Nuk gjetëm asnjë çelës DKIM te {selectors}. Pa të, përgjigjet tuaja nuk nënshkruhen dhe kanë më shumë gjasa të përfundojnë te spami. Aktivizoni nënshkrimin DKIM për domenin te ofruesi juaj i email-it."
        },
        "dmarc_missing": {
          "TITLE": "Mungon regjistrimi DMARC",
          "DESCRIPTION": "Ofruesit e mëdhenj të postës, si Gmail dhe Microsoft, presin një regjistrim DMARC. Pa të, përgjigjet tuaja kanë më shumë gjasa të përfundojnë te spami."
        },
        "dmarc_fails": {
          "TITLE": "DMARC i thotë marrësve t'i refuzojnë përgjigjet tuaja",
          "DESCRIPTION": "Politika DMARC e domenit është «{policy}» dhe përgjigjet tuaja nuk kalojnë as SPF as DKIM, ndaj marrësit i refuzojnë ose i zhvendosin te spami. Rregulloni SPF dhe DKIM më sipër."
        },
        "dmarc_blocks_platform": {
          "TITLE": "DMARC bllokon përgjigjet e dërguara përmes serverave tanë postarë",
          "DESCRIPTION": "Kjo kuti postare i dërgon përgjigjet përmes serverave tanë postarë, por politika DMARC e domenit është «{policy}», ndaj marrësit i refuzojnë ose i zhvendosin te spami. Konfiguroni SMTP të serverit tuaj postar për këtë kuti postare."
        },
        "mx_missing": {
          "TITLE": "Domeni nuk ka regjistrim MX",
          "DESCRIPTION": "Pa një regjistrim MX askush nuk mund t'i dërgojë email domenit, ndaj klientët nuk mund t'u përgjigjen përgjigjeve tuaja."
        }
      }
    },
    "NOTE": "Note: ",
    "WIDGET_BUILDER": {
      "WIDGET_OPTIONS": {
        "AVATAR": {
          "LABEL": "Website Avatar",
          "DELETE": {
            "API": {
              "SUCCESS_MESSAGE": "Avatar deleted successfully",
              "ERROR_MESSAGE": "There was an error, please try again"
            }
          }
        },
        "WEBSITE_NAME": {
          "LABEL": "Website Name",
          "PLACE_HOLDER": "Enter your website name (eg: Acme Inc)",
          "ERROR": "Please enter a valid website name"
        },
        "WELCOME_HEADING": {
          "LABEL": "Welcome Heading",
          "PLACE_HOLDER": "Hi there!"
        },
        "WELCOME_TAGLINE": {
          "LABEL": "Welcome Tagline",
          "PLACE_HOLDER": "We make it simple to connect with us. Ask us anything, or share your feedback."
        },
        "REPLY_TIME": {
          "LABEL": "Reply Time",
          "IN_A_FEW_MINUTES": "In a few minutes",
          "IN_A_FEW_HOURS": "In a few hours",
          "IN_A_DAY": "In a day"
        },
        "WIDGET_COLOR_LABEL": "Widget Color",
        "WIDGET_BUBBLE_POSITION_LABEL": "Widget Bubble Position",
        "UNREAD_MESSAGES_MAX_HEIGHT": {
          "LABEL": "Lartësia maksimale e mesazheve të palexuara (px)",
          "PLACE_HOLDER": "Pa kufi",
          "HELP_TEXT": "Kufizoni lartësinë maksimale të dritares së mesazheve të palexuara në piksel. Lëreni bosh për sjelljen e parazgjedhur (pa kufi)."
        },
        "WIDGET_BUBBLE_TYPE_LABEL": "Widget Bubble Type",
        "WIDGET_BUBBLE_LAUNCHER_TITLE": {
          "DEFAULT": "Chat with us",
          "LABEL": "Widget Bubble Launcher Title",
          "PLACE_HOLDER": "Chat with us"
        },
        "UPDATE": {
          "BUTTON_TEXT": "Update Widget Settings",
          "API": {
            "SUCCESS_MESSAGE": "Widget settings updated successfully",
            "ERROR_MESSAGE": "Unable to update widget settings"
          }
        },
        "WIDGET_VIEW_OPTION": {
          "PREVIEW": "Preview",
          "SCRIPT": "Script"
        },
        "WIDGET_BUBBLE_POSITION": {
          "LEFT": "Left",
          "RIGHT": "Right"
        },
        "WIDGET_BUBBLE_TYPE": {
          "STANDARD": "Standard",
          "EXPANDED_BUBBLE": "Expanded Bubble"
        }
      },
      "WIDGET_SCREEN": {
        "DEFAULT": "Default",
        "CHAT": "Chat"
      },
      "REPLY_TIME": {
        "IN_A_FEW_MINUTES": "Zakonisht përgjigjemi brenda pak minutash",
        "IN_A_FEW_HOURS": "Zakonisht përgjigjemi brenda disa orësh",
        "IN_A_DAY": "Zakonisht përgjigjemi brenda një dite"
      },
      "FOOTER": {
        "START_CONVERSATION_BUTTON_TEXT": "Hap Bisedën",
        "CHAT_INPUT_PLACEHOLDER": "Shkruani mesazhin tuaj"
      },
      "BODY": {
        "TEAM_AVAILABILITY": {
          "ONLINE": "We are Online",
          "OFFLINE": "Nuk jemi online për momentin"
        },
        "USER_MESSAGE": "Hi",
        "AGENT_MESSAGE": "Hello"
      },
      "BRANDING_TEXT": "Powered by JARABOT",
      "SCRIPT_SETTINGS": "\n      window.jarabotSettings = {options};"
    },
    "EMAIL_PROVIDERS": {
      "MICROSOFT": "Microsoft",
      "GOOGLE": "Google",
      "OTHER_PROVIDERS": "Other Providers"
    },
    "CHANNELS": {
      "MESSENGER": "Messenger",
      "WEB_WIDGET": "Faqe interneti",
      "TWITTER_PROFILE": "Twitter",
      "TWILIO_SMS": "Twilio SMS",
      "WHATSAPP": "WhatsApp",
      "SMS": "SMS",
      "SMS_BRANA": "SMS Brana",
      "DIDWW": "DIDWW",
      "EMAIL": "Email",
      "TELEGRAM": "Telegram",
      "LINE": "Line",
      "API": "API Channel",
      "PHONE": "Telefon SIP",
      "INSTAGRAM": "Instagram",
      "SALESFORCE": "Salesforce",
      "ALLEGRO": "Allegro",
      "KAUFLAND": "Kaufland"
    }
  }
}
